import { useState } from 'react';
import './styles.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import PreFooter from '../../components/PreFooter';
import Popup from '../../components/Popup';
import Question from './question';

const QUESTIONS = [
  {
    question: 'What is a travel nurse?',
    answer:
      'A travel nurse is a registered nurse who takes short-term assignments—typically 8 to 26 weeks—at hospitals and healthcare facilities across the country. Travel nurses help fill staffing shortages while enjoying higher pay, flexibility, and the opportunity to explore new locations.',
  },
  {
    question: 'What are travel allied health jobs?',
    answer:
      'Travel allied health jobs are short-term healthcare assignments for professionals such as radiology techs, respiratory therapists, physical therapists, lab techs, and surgical technologists. Like travel nursing, these roles offer competitive pay, flexible contracts, and nationwide opportunities.',
  },
  {
    question: 'How much do travel nurses and allied health professionals get paid?',
    answer:
      'Pay varies by specialty, location, and demand, but travel healthcare jobs often pay more than permanent positions. Most pay packages include an hourly rate plus tax-free housing and meal stipends, and sometimes bonuses.',
  },
  {
    question: 'Do I need experience to work as a travel nurse or allied health professional?',
    answer:
      'Most travel jobs require at least 1–2 years of recent experience in your specialty. Some facilities may accept less experience depending on demand and role.',
  },
  {
    question: 'Do you help with housing?',
    answer:
      'Yes! Many travel healthcare professionals choose either agency-provided housing or a housing stipend so they can find their own place. We’ll help you decide what works best for you.',
  },
  {
    question: 'What licenses or certifications do I need?',
    answer:
      'Licensing requirements depend on the state and your profession. We help with state licenses, certifications, and credentialing to make the process as smooth as possible.',
  },
  {
    question: 'How long are travel assignments?',
    answer:
      'Most travel assignments last 13 weeks, but shorter and longer contracts are available depending on the facility and specialty.',
  },
  {
    question: 'Can I choose where I want to work?',
    answer:
      'Absolutely. You decide where you want to go, how long you want to stay, and what kind of facility you prefer. We’ll only submit you to jobs you’re interested in.',
  },
  {
    question: 'Is travel healthcare a good option for first-time travelers?',
    answer:
      'Yes! Travel nursing and allied health travel jobs are great for first-time travelers. Our team walks you through every step—from your first application to your first day on assignment.',
  },
  {
    question: 'Do travel jobs offer benefits?',
    answer:
      'Many travel healthcare positions offer benefits such as health insurance, retirement options, referral bonuses, and paid time off, depending on the contract.',
  },
  {
    question: 'How do I get started?',
    answer:
      'Getting started is easy! Just apply online or talk to a recruiter. We’ll learn about your goals, match you with open travel healthcare jobs, and help you land your next assignment.',
  },
];

const FAQ = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />

      <div className='nursePageContent'>
        <div className='nurseBackLink' onClick={() => navigate('/travel_nurse')}>
          <svg xmlns='http://www.w3.org/2000/svg' width='11' height='11' viewBox='0 0 11 11' fill='none'>
            <path
              d='M5.33073 9.99833L0.664062 5.33167M0.664062 5.33167L5.33073 0.665001M0.664062 5.33167H9.9974'
              stroke='#3A6376'
              stroke-width='1.33'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </svg>
          Travel Nursing
        </div>

        <h1 className='nursePageTitle'>Frequently Asked Questions</h1>
        <div className='nurseQuestions'>
          {QUESTIONS.map(item => (
            <Question data={item} />
          ))}
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <PreFooter
        title='Ready to Find Your Next Travel Assignment?'
        text='Your skills are needed—and your career deserves flexibility, great pay, and support you can count on.'
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
      />
      <Footer />
    </div>
  );
};

export default FAQ;
